import { RemittanceFileRecord } from './remittance-file-record';
import { DateUtils } from '../../utils/date-utils';
import { DateConversionUtils } from '../../utils/date-conversion-utils';
import { Deserializable } from '../protocols/deserializable';
import { UniquelyIdentifiable } from '../protocols/uniquely-identifiable';

export class ContributionEntry implements Deserializable, UniquelyIdentifiable {
  id!: string;
  contributionId!: string;
  codeId!: number;
  payPeriodEndDate!: string;
  taxationYear!: string;
  amount!: number;

  constructor(record?: RemittanceFileRecord) {
    if (record) {
      this.codeId = record['ENTRY CODE'];
      this.payPeriodEndDate = DateConversionUtils.dateToNativeInput(
        DateUtils.convertCSVDateStringToUTCDate(record['PAY PERIOD END DATE'])
      );
      this.taxationYear = DateUtils.yearToDateOnlyString(record['TAXATION YEAR']);
      this.amount = record.AMOUNT;
    }
  }

  onDeserialize() {}

  getUniqueIdentifier(): string {
    return `${this.id}-
    ${this.contributionId}-
    ${this.codeId}-
    ${this.payPeriodEndDate}-
    ${this.taxationYear}-
    ${this.amount}`;
  }
}
